<template>
  <div :id="`chart${id}`" :ref="`chart${id}`" style="width: 100%"></div>
</template>

<script>

import ApexCharts from 'apexcharts'


export default {
  props: ['chartdata'],

  data() {
    return {
      options : {
        chart: {
          type: 'line',
          animations: {
              enabled: true,
              easing: 'linear',
              dynamicAnimation: {
                speed: 1000
              }
            }
        },
        series: [{
          name: 'displayed',
          data: this.chartdata.yaxis
        }],
        xaxis: {
          categories: this.chartdata.xaxis
        },
      },

      id: Math.floor(Math.random(999) * 100) + Math.floor(Math.random(999) * 100),
      chart: null
    }
  },

  mounted () {
    this.chart = new ApexCharts(document.querySelector(`#chart${this.id}`), this.options);

    this.chart.render();
  },

  watch: {
    chartdata: function (val) {
      this.chart.updateSeries([{
        data: this.chartdata.yaxis
      }])
    }
  }
}
</script>

<style>
</style>